import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Briefcase, ChevronDown, Handshake, ShieldCheck } from "lucide-react";
import { Icon } from "./Icon";
function readEnv(envKey, fallback) {
    const viteEnv = import.meta.env;
    if (viteEnv?.[envKey])
        return viteEnv[envKey];
    return fallback;
}
// Default URLs are RELATIVE so they work for both local dev (each portal
// on its own Vite port; cross-portal nav opens a new origin which is fine
// for the demo) and the combined Railway deploy at web/portal-deploy/
// where all 5 portals live under one origin at /investor, /distributor,
// /ops, etc. Override per env if a portal needs to point somewhere else.
export const DEFAULT_PERSONAS = [
    {
        id: "investor",
        label: "Investor",
        url: readEnv("VITE_INVESTOR_URL", "/investor/products"),
        icon: Briefcase,
    },
    {
        id: "distributor",
        label: "Distributor",
        url: readEnv("VITE_DISTRIBUTOR_URL", "/distributor/approvals"),
        icon: Handshake,
    },
    {
        id: "ops",
        label: "Operator",
        url: readEnv("VITE_OPS_URL", "/ops/audit"),
        icon: ShieldCheck,
    },
];
const triggerStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px",
    background: "var(--hydrax-color-surface)",
    border: "1px solid var(--hydrax-color-border)",
    borderRadius: "var(--hydrax-radius-sm)",
    color: "var(--hydrax-color-text-strong)",
    fontFamily: "var(--hydrax-font-sans)",
    fontSize: "var(--hydrax-type-bodySm-size)",
    cursor: "pointer",
};
const menuStyle = {
    position: "absolute",
    top: "calc(100% + 4px)",
    right: 0,
    minWidth: 220,
    padding: 4,
    background: "var(--hydrax-color-surface)",
    border: "1px solid var(--hydrax-color-border)",
    borderRadius: "var(--hydrax-radius-sm)",
    boxShadow: "var(--hydrax-shadow-md)",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    zIndex: 20,
};
const linkBaseStyle = {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 10px",
    textDecoration: "none",
    color: "var(--hydrax-color-text)",
    borderRadius: "var(--hydrax-radius-sm)",
    fontFamily: "var(--hydrax-font-sans)",
    fontSize: "var(--hydrax-type-bodySm-size)",
};
export function PersonaSwitcher({ current, personas = DEFAULT_PERSONAS }) {
    const [open, setOpen] = useState(false);
    const currentPersona = personas.find((p) => p.id === current) ?? personas[0];
    if (!currentPersona)
        return null;
    return (_jsxs("div", { style: { position: "relative" }, children: [_jsxs("button", { type: "button", "aria-label": "Switch persona", "aria-haspopup": "menu", "aria-expanded": open, onClick: () => setOpen((o) => !o), style: triggerStyle, children: [_jsx(Icon, { icon: currentPersona.icon, label: currentPersona.label, size: 14 }), _jsx("span", { "data-mobile-collapse": "persona-label", children: currentPersona.label }), _jsx(Icon, { icon: ChevronDown, label: "Open menu", size: 12 })] }), open ? (_jsx("div", { role: "menu", style: menuStyle, children: personas.map((p) => (_jsxs("a", { href: p.url, role: "menuitem", style: {
                        ...linkBaseStyle,
                        background: p.id === current ? "var(--hydrax-color-bg)" : "transparent",
                    }, children: [_jsx(Icon, { icon: p.icon, label: p.label, size: 14 }), _jsx("span", { children: p.label })] }, p.id))) })) : null] }));
}
//# sourceMappingURL=PersonaSwitcher.js.map